/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Customer} from './Customer';
import {Settings} from './Settings';
import {Warehouse} from './Warehouse';
import {CartProduct} from './CartProduct';

export interface InitData {
  user: Customer;
  settings: Settings;
  warehouseList: Warehouse[];
  cart?: CartProduct[];
}
